<script setup lang="ts">
// Portierung von Angular `kgr-menu-language-switch`: reine Select-Box zur Wahl
// der Anzeigesprache. Die eigentliche Locale-Umschaltung (i18n laden, Route
// anpassen) bleibt beim Aufrufer — hier wird nur `localeChanged` emittiert.
defineProps<{
    locales: string[]
    activeLocale: string
}>();

const emit = defineEmits<{
    localeChanged: [localeId: string]
}>();

const languageNames: Record<string, string> = {
    de: 'Deutsch',
    en: 'English',
    es: 'Español',
    tr: 'Türkçe',
    uk: 'Українська',
};

function getLanguageName(localeId: string): string {
    return languageNames[localeId] ?? localeId;
}

function onChange(event: Event) {
    emit('localeChanged', (event.target as HTMLSelectElement).value);
}
</script>

<template>
    <select
        class="kgr-select"
        :value="activeLocale"
        :aria-label="$t('Anzeigesprache wählen')"
        @change="onChange"
    >
        <option
            v-for="localeId in locales"
            :key="localeId"
            :value="localeId"
            :selected="localeId === activeLocale"
        >
            {{ getLanguageName(localeId) }}
        </option>
    </select>
</template>
